<template>
  <div class="login-wrap">
    <div class="page-login--layer page-login--layer-area">
      <ul class="circles">
        <li v-for="n in 10" :key="n"></li>
      </ul>
    </div>
    <div class="page-login--layer page-login--layer-time" flex="main:center cross:center">
      {{ date.time }}
    </div>
    <div class="ms-login">
      <div class="ms-content">
        <div class="nav">
          <img src="@/assets/img/login/nav.png" />
        </div>
        <div class="form">
          <div class="form-top">
            <div class="come">welcome！</div>
            <div class="tip">立即登陆</div>
          </div>
          <el-form :model="param" :rules="rules" ref="login" label-width="0px">
            <el-form-item prop="username">
              <el-input v-model="param.username" placeholder="请输入用户名">
                <template #prefix>
                  <img class="form-img" src="@/assets/img/login/user.png" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" placeholder="请输入密码" v-model="param.password" @keyup.enter="submitForm()">
                <template #prefix>
                  <img class="form-img" src="@/assets/img/login/password.png" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked1" label="记住密码" size="default"></el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loginLoading" type="primary" @click="submitForm()">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="page-login--content-footer">
      <p class="page-login--content-footer-copyright">
        Copyright
        <d2-icon name="copyright" />
        2023 广州爱析科技有限公司
      </p>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import service from '@/utils/request'
// import { useStore } from 'vuex'

export default {
  setup() {
    // const store = useStore()
    const date = reactive({
      time: dayjs().format('HH:mm:ss')
    })
    const timer = ref()
    const loginLoading = ref(false)
    const router = useRouter()
    const param = reactive({
      username: '',
      password: '',
    })

    onMounted(() => {
      timer.value = setInterval(() => {
        refreshTime()
      }, 1000)
    })

    const refreshTime = () => {
      date.time = dayjs().format('HH:mm:ss')
    }

    const rules = {
      username: [
        {
          required: true,
          message: '请输入用户名',
          trigger: 'blur',
        },
      ],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    }
    const login = ref(null)
    const submitForm = () => {
      login.value.validate(async (valid) => {
        if (valid) {
          loginLoading.value = true
          let res = await service.post('/api/login/index', param)
          loginLoading.value = false
          if (res.code === 0) {
            ElMessage.success(res.msg)
            localStorage.setItem('ms_token', res.data.userData.token)
            localStorage.setItem('ms_username', res.data.name)
            if (res.data.role) {
              localStorage.setItem('ms_role_type', res.data.role.role_type)
            }
            let userData = res.data
            userData.uid = res.data.id
            localStorage.setItem('ms_userData', JSON.stringify(userData))
            router.push('/')
            // store.dispatch('permission/generateRoutes').then(() => {
            //   router.push('/')
            // })
          }
        } else {
          // ElMessage.error('登录成功')
          return false
        }
      })
    }

    return {
      loginLoading,
      refreshTime,
      param,
      date,
      timer,
      rules,
      login,
      submitForm,
    }
  },
}
</script>

<style scoped lang="scss">
.ms-login {
  &:deep(.el-form-item) {
    .el-form-item--large .el-form-item__content {
      line-height: 56px;
    }

    .el-input--large {
      line-height: 54px;
    }

    .el-input--large .el-input__inner {
      height: 56px;
      line-height: 56px;
      border-radius: 32px;
      padding-left: 55px;
      font-size: 14px;
    }
  }

  .el-button {
    height: 32px;
    background: #3166ae;
    border-radius: 16px;
    width: 100%;
    font-size: 13px;
    font-family: 'Source Han Sans CN-Medium';
  }
}

  // 背景
  .circles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0px;
    padding: 0px;
    li {
      position: absolute;
      display: block;
      list-style: none;
      width: 20px;
      height: 20px;
      background: #FFF;
      animation: animate 25s linear infinite;
      bottom: -200px;
      @keyframes animate {
        0%{
          transform: translateY(0) rotate(0deg);
          opacity: 1;
          border-radius: 0;
        }
        100%{
          transform: translateY(-1000px) rotate(720deg);
          opacity: 0;
          border-radius: 50%;
        }
      }
      &:nth-child(1) {
        left: 15%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
      }
      &:nth-child(2) {
        left: 5%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 12s;
      }
      &:nth-child(3) {
        left: 70%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
      }
      &:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-delay: 0s;
        animation-duration: 18s;
      }
      &:nth-child(5) {
        left: 65%;
        width: 20px;
        height: 20px;
        animation-delay: 0s;
      }
      &:nth-child(6) {
        left: 75%;
        width: 150px;
        height: 150px;
        animation-delay: 3s;
      }
      &:nth-child(7) {
        left: 35%;
        width: 200px;
        height: 200px;
        animation-delay: 7s;
      }
      &:nth-child(8) {
        left: 50%;
        width: 25px;
        height: 25px;
        animation-delay: 15s;
        animation-duration: 45s;
      }
      &:nth-child(9) {
        left: 20%;
        width: 15px;
        height: 15px;
        animation-delay: 2s;
        animation-duration: 35s;
      }
      &:nth-child(10) {
        left: 85%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 11s;
      }
    }
  }

// footer
.page-login--content-footer {
  padding: 1em 0;
  position: fixed;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .page-login--content-footer-locales {
    padding: 0px;
    margin: 0px;
    margin-bottom: 15px;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #606266;

    a {
      color: #606266;
      margin: 0 .5em;

      &:hover {
        color: #606266;
      }
    }
  }

  .page-login--content-footer-copyright {
    padding: 0px;
    margin: 0px;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #606266;

    a {
      color: #606266;
    }
  }

  .page-login--content-footer-options {
    padding: 0px;
    margin: 0px;
    font-size: 12px;
    line-height: 12px;
    text-align: center;

    a {
      color: #606266;
      margin: 0 1em;
    }
  }
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #F0F2F5;

  .page-login--layer {

    overflow: auto;
  }

  .page-login--layer-area {
    overflow: hidden;
  }

  // 时间
  .page-login--layer-time {
    text-align: center;
    font-size: 24em;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.03);
    overflow: hidden;
    font-family: 'Helvetica Neue';
  }
}

.ms-title {
  font-family: SourceHanSansCNBold;
  font-weight: bold;
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 300px;
  margin: auto;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;

  .login {
    margin-top: 56px;
    margin-left: 80px;

    .img {
      width: 48px;
      height: 48px;
      float: left;
    }

    .text {
      margin-left: 64px;

      .name {
        font-size: 24px;
        font-family: 'lianmengqiyilushuaizhengruiheiti-Regular';
        font-weight: 400;
        color: #3166ae;
        line-height: 48px;
        letter-spacing: 4px;
      }

      .pid {
        font-size: 14px;
        font-family: 'Source Han Sans SC-Medium';
        font-weight: 500;
        color: #3166ae;
        line-height: 14px;
        margin-top: 16px;
      }
    }
  }
}

.ms-content {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .nav {
    max-width: 250px;

    img {
      width: 250px;
      margin-top: 20px;
      max-width: 100%;
    }
  }

  .form {
    width: 260px;

    &:deep(.el-input__prefix) {
      left: 6px;
    }

    .form-img {
      height: 22px;
      margin-top: 5px;
    }

    .form-top {
      .come {
        font-size: 24px;
        font-family: 'Source Han Sans CN-Bold';
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        margin-top: 20px;
      }

      .tip {
        font-size: 14px;
        font-family: 'Source Han Sans CN-Medium';
        font-weight: 500;
        color: #333333;
        margin-top: 17px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
